module.exports = __webpack_public_path__ + "static/media/white-ny.2bfc1a82.png";